module.exports = __webpack_public_path__ + "static/fernandocv-7b72631578f84c0793427ba421bb19cf.pdf";